import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Divider,
  Grid,
} from '@material-ui/core';

import i18n from '../../i18n';

class BookingFormHeader extends Component {
  render() {
    const {
      locationId,
      locationName,
      handleSave
    } = this.props;

    return (
      <>
        <Grid item xs={7}>
          <Box
            fontSize="h4.fontSize"
            fontWeight="fontWeightBold"
            textAlign="right"
          >
            {locationName}
          </Box>
        </Grid>
        <Grid item xs={5}>
          <Box textAlign="right">
            <Button
              className="saveButtonBookingForm ssensePrimary"
              onClick={handleSave}
              name={locationId}
            >
              {i18n.t('save')}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider className="form-divider" />
        </Grid>
      </>
    )
  }
}

BookingFormHeader.propTypes = {
  locationId: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default BookingFormHeader;
